import { BrowserRouter,Route,Routes,Navigate,useLocation,HashRouter } from 'react-router-dom';
import Navbar from './components/navbar';
import Request from './components/reqeust';
import Login from './components/login';
import  AuthProvider  from './AuthProvider';
import { useAuth } from './AuthContext.js';
import Profile from './components/profile';
import Teacher from './components/teacher/teacher.js';

import React from 'react';
import { useEffect, useState } from "react";
import './App.css';
import ProfileCard from './components/form.js';
import Student from './components/student/student.js';
import Header from './components/Header'
import Footer from './components/Footer/footer.js';
import Dashboard from './components/DashBoard/dashboard.js';
import { LoaderProvider } from './LoaderContext.js';


const Layout = () => {
  const { isAuthenticated,setIsAuthenticated,setUser,isCollapsed,setIsCollapsed } = useAuth();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const location = useLocation();

  useEffect(() => {
    if(isMobile){
      setIsCollapsed(true)
    }
   
  }, [location]);

  useEffect(()=>{
    const token = localStorage.getItem('jwtToken');
    const user = localStorage.getItem('user');

  
    if(token){

      setIsAuthenticated(true)
    }else{
      setIsAuthenticated(false)
    }
    if(user){
    
      setUser(JSON.parse(user))
      console.log(JSON.parse(user),"user")
    }

  },[])


  const PrivateRoute = ({ isAuthenticated, children }) => {
  return isAuthenticated ? children : <Navigate to="/login" />;
};





  return (
    
    <div className="app-layout" >
      {isAuthenticated && <Navbar />}
      <div className={`main-content ${(isMobile && !isCollapsed) ? "mobile" : "web"}`}>
        {isAuthenticated && <Header/>}
        <Routes>
          <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
          <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} />

          {/* Protected Routes */}
          <Route path="/dashboard" element={<PrivateRoute isAuthenticated={isAuthenticated}><Dashboard /></PrivateRoute>} />
          <Route path="/request" element={<PrivateRoute isAuthenticated={isAuthenticated}><Request /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute isAuthenticated={isAuthenticated}><Profile /></PrivateRoute>} />
          <Route path="/teacher" element={<PrivateRoute isAuthenticated={isAuthenticated}><Teacher /></PrivateRoute>} />
          <Route path="/students" element={<PrivateRoute isAuthenticated={isAuthenticated}><Student /></PrivateRoute>} />
          <Route path="/form" element={<PrivateRoute isAuthenticated={isAuthenticated}><ProfileCard /></PrivateRoute>} />
        </Routes>

       {isAuthenticated && <Footer/>}
      </div>
    </div>
  );
};

const App =() =>{

  return (
    <AuthProvider>
      <LoaderProvider>
      <HashRouter>
       <div className='route-content'>
        <Layout />
        </div>
      </HashRouter>
      </LoaderProvider>
    </AuthProvider>
  );
}

export default App;




